import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCopy,
  faCheck,
  faArrowRight,
  faGlobe,
} from '@fortawesome/free-solid-svg-icons';
import StoreHeader from '../../components/StoreHeader';
import Footer from '../../components/Footer';
import { formatValidity } from '../../utils/formatters';
import './ordersuccess.css';

// Checkout/capture sonrası bu sayfaya { qrCodeData, plan } state'i ile gelinir.
// Checkout henüz hazır olmadığından, state yoksa önizleme için demo veri kullanılır.
const DEMO = {
  qrCodeData: 'LPA:1$rsp.truphone.com$UTKAN-DEMO-ACTIVATION-CODE-001',
  plan: {
    countryName: 'Türkiye',
    dataAmount: '10 GB',
    validity: '30',
    flag: 'https://myaccount.keepgo.com/img/flags/3x2/tr.svg',
  },
};

const OrderSuccess = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [copied, setCopied] = useState(false);

  const data = location.state?.qrCodeData ? location.state : DEMO;
  const { qrCodeData, plan = {} } = data;
  const steps = ['order.step1', 'order.step2', 'order.step3', 'order.step4'];

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(qrCodeData);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard yoksa sessiz geç */
    }
  };

  // validity sayı ise "X gün" (0 → "Süresiz"), değilse olduğu gibi göster.
  const validityText = formatValidity(t, plan.validity);

  return (
    <div className="order">
      <StoreHeader />

      <main className="order-main">
        {/* Başarı başlığı */}
        <div className="order-hero">
          <span className="order-check">
            <FontAwesomeIcon icon={faCircleCheck} />
          </span>
          <h1 className="order-congrats">{t('order.congrats')}</h1>
          <p className="order-message">{t('order.message')}</p>
        </div>

        {/* Sipariş özeti */}
        <section className="order-section">
          <h2 className="order-section-title">{t('order.details')}</h2>
          <div className="order-summary">
            {plan.flag ? (
              <img className="order-summary-flag" src={plan.flag} alt="" />
            ) : (
              <span className="order-summary-flag order-summary-flag--fallback">
                <FontAwesomeIcon icon={faGlobe} />
              </span>
            )}
            <div>
              <span className="order-summary-name">
                {plan.countryName} · {plan.dataAmount}
              </span>
              {validityText && (
                <span className="order-summary-validity">
                  {t('detail.validityLabel')}: {validityText}
                </span>
              )}
            </div>
          </div>
        </section>

        {/* Aktivasyon + QR */}
        <section className="order-section">
          <h2 className="order-section-title">{t('order.activation')}</h2>
          <p className="order-activation-desc">{t('order.activationDesc')}</p>

          <div className="order-qr-card">
            <div className="order-qr">
              <QRCodeSVG value={qrCodeData} size={196} level="M" includeMargin />
            </div>
            <span className="order-qr-title">{t('order.qrTitle')}</span>
          </div>

          <div className="order-manual">
            <span className="order-manual-label">{t('order.manualLabel')}</span>
            <div className="order-manual-row">
              <code>{qrCodeData}</code>
              <button type="button" className="order-copy" onClick={copyCode}>
                <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
                {copied ? t('order.copied') : t('order.copy')}
              </button>
            </div>
          </div>
        </section>

        {/* Kurulum adımları */}
        <section className="order-section">
          <h2 className="order-section-title">{t('order.howTo')}</h2>
          <ol className="order-steps">
            {steps.map((key, i) => (
              <li key={key}>
                <span className="order-step-num">{i + 1}</span>
                <span className="order-step-text">{t(key)}</span>
              </li>
            ))}
          </ol>
        </section>

        <Link to="/" className="order-cta">
          {t('order.cta')}
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </main>

      <Footer />
    </div>
  );
};

export default OrderSuccess;
